import { RotationOffsets } from '@cartwhl/common/types';

import apiRequest from './apiRequest';
import { Markers } from './postCharacter';

export default async function putCharacter(
  characterID: string,
  props: {
    characterName?: string;
    bodyMarkerPositions?: Markers;
    predictedMapping?: Record<string, string>;
    autoRig?: boolean;
    wsConnectionID?: string;
    wsHttpEndpoint?: string;
    rotationOffsets?: RotationOffsets;
  },
) {
  return await apiRequest('mogen-orchestration', `/characters/${characterID}`, {
    method: 'PUT',
    body: JSON.stringify(props),
  });
}
